import { FileDto } from "@/lib/gen-api";
import { ExternalFileProviderIcon } from "../display-icon/ExternalFileProviderIcon";

type ExternalProvider = FileDto["externalProvider"];
type NoUndefined<T> = T extends null | undefined ? never : T;
type FileExternalProvider = Exclude<NoUndefined<ExternalProvider>, "FIREFLIES">;

type ExternalFileProviderDisplayNameProps = {
  externalProvider: ExternalProvider;
};

const PROVIDER_LABELS_MAP: Record<FileExternalProvider, string> = {
  GOOGLE_DRIVE: "Google Drive",
  DROPBOX: "Dropbox",
  ONEDRIVE: "OneDrive",
  SHAREPOINT: "SharePoint",
};

function providerLabel(
  externalProvider: NonNullable<ExternalProvider>,
): string {
  if (externalProvider === "FIREFLIES") {
    return "External";
  }

  return PROVIDER_LABELS_MAP[externalProvider];
}

export const ExternalFileProviderDisplayName = (
  props: ExternalFileProviderDisplayNameProps,
) => {
  if (props.externalProvider === null) {
    return null;
  }

  const label = providerLabel(props.externalProvider);

  return (
    <div className="flex flex-row items-center gap-1">
      <ExternalFileProviderIcon externalProvider={props.externalProvider} />
      {label}
    </div>
  );
};
